'use es6';

import { PopoverType } from '../../constants/popover';
import PersonalizePopoverBody from './PersonalizePopoverBody';
import { jsx as _jsx } from "react/jsx-runtime";
function PersonalizePopoverBodyInsertLegacy(props) {
  return /*#__PURE__*/_jsx(PersonalizePopoverBody, Object.assign({}, props, {
    type: PopoverType.INSERT
  }));
}
PersonalizePopoverBodyInsertLegacy.displayName = 'PersonalizePopoverBodyInsertLegacy';
export default PersonalizePopoverBodyInsertLegacy;